import React from 'react';
import compact from 'lodash/compact';
import isEmpty from 'lodash/isEmpty';
import {
  NpiDTO,
} from 'dtos';

type Props = NpiDTO & {
  state?: string | null;
};

export default function NPIInfo({ state, ...npi }: Props) {
  const { number, taxonomyCode, type } = npi;
  return (
    <small className="flex items-center gap-2">
      {isEmpty(npi)
        ? 'No NPI'
        : compact([type, number, taxonomyCode, state]).join(' • ')}
    </small>
  );
}
